export default __webpack_public_path__ + "static/media/Contact_BG-02.fe0f6573.png";